import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import {
    createHandlerChainRunnerOptionalParameter,
    Handler,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import ReCAPTCHA from "react-google-recaptcha";

interface ExtendedHasOnSuccess extends HasOnSuccess<boolean> {
    captchaIds: string[];
    location: string
}

type HandlerType = Handler<ExtendedHasOnSuccess, {location: string; recaptchaRef: React.RefObject<ReCAPTCHA>; errorMessage: string }>;

// type HandlerType = Handler<
//     { location: string; recaptchaRef: React.RefObject<ReCAPTCHA> } & HasOnSuccess<boolean>,
//     { errorMessage: string }
// >;

export const Validate: HandlerType = props => {
    const grecaptcha = (window as { [key: string]: any })["grecaptcha"];
    if (grecaptcha === undefined) {
        return;
    }

    const { captchaIds } = props.parameter;
    for (const captchaId of captchaIds) {
        const reCaptchaElement = document.getElementById(captchaId);
        if (!reCaptchaElement) {
            return;
        }

        if (getCookie(`${captchaId}-g-recaptcha-verified`)) {
            return;
        }

        const reCaptchaResponse = grecaptcha.getResponse(captchaId);
        setCookie(`${captchaId}-g-recaptcha-response`, reCaptchaResponse);

        props.errorMessage = reCaptchaResponse ? "" : (siteMessage("ReCaptcha_RequiredErrorMessage") as string);
        props.dispatch({
            type: "Components/ReCaptcha/SetErrorMessage",
            errorMessage: props.errorMessage,
            location: props.parameter?.location,
        });
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(!props.errorMessage);
};

export const chain = [Validate, ExecuteOnSuccessCallback];

const multiplevalidateReCaptcha = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        captchaIds: [],
        location:""
    },
    "MultiplevalidateReCaptcha",
);
export default multiplevalidateReCaptcha;
